
import { createReducer } from '@reduxjs/toolkit';
import * as Actions from '../actions/ProfileActions';

const initialUser = {
    userId: null,
    email: null,
    name: null,
    lastName: null,
    gender: null,
    birthday: null,
    cpf: null,
    telefone: null,
    cep: null,
    district: null,
    street: null,
    streetNumber: null,
    addressSupplement: null,
    cityId: null,
    stateId: null,
    emailConfirmed: null,
    newsletter: null,
    isPro: null,
    registrationComplete: null,
};

const initialState = {
    jwt: null,
    browserHash: null,
    sessionHash: null,
    isOpen: false,
    submitting: false,
    firebasePopupOpen: false,
    resending: false,
    statusOfEmailResent: false,
    cities: [],
    states: [],
    currentStateId: false,
    passwordResetRequested: false,
    passwordResetted: false,
    profileInitialized: false, // this is true once the profile was fetched or the appComponent didMount was called without a jwt
    fetchingProfile: false,
    user: { ...initialUser },
};

const profile = createReducer(initialState, (builder) => {
    builder
        .addCase(Actions.SET_AUTH, (state, action) => {
            state.jwt = action.jwt;
        })
        .addCase(Actions.SET_PROFILE_MODAL, (state, action) => {
            state.isOpen = action.isOpen;
        })
        .addCase(Actions.SET_SUBMITTING_PROFILE, (state, action) => {
            state.submitting = action.submittingType;
        })
        .addCase(Actions.UNSET_SUBMITTING_PROFILE, (state) => {
            state.submitting = false;
        })
        .addCase(Actions.SET_RESENDING, (state) => {
            state.resending = true;
        })
        .addCase(Actions.UNSET_RESENDING, (state) => {
            state.resending = false;
        })
        .addCase(Actions.SET_EMAIL_RESENT_SUCCESSFULY, (state) => {
            state.statusOfEmailResent = true;
        })
        .addCase(Actions.SET_STORE_PROFILE, (state, action) => {
            state.user = { ...state.user, ...action.user };
            state.profileInitialized = true;
            state.fetchingProfile = false;
        })
        .addCase(Actions.RESET_STORE_PROFILE, (state) => {
            state.user = { ...initialUser };
        })
        .addCase(Actions.SET_STATES, (state, action) => {
            state.states = action.states;
        })
        .addCase(Actions.SET_CITIES, (state, action) => {
            state.cities = action.cities;
            state.currentStateId = action.currentStateId;
        })
        .addCase(Actions.SET_PASSWORD_RESET_REQUESTED, (state, action) => {
            state.passwordResetRequested = action.passwordResetRequested;
        })
        .addCase(Actions.SET_PASSWORD_RESETTED, (state, action) => {
            state.passwordResetted = action.passwordResetted;
        })
        .addCase(Actions.SET_BROWSER_HASH, (state, action) => {
            state.browserHash = action.browserHash;
        })
        .addCase(Actions.SET_SESSION_HASH, (state, action) => {
            state.sessionHash = action.sessionHash;
        })
        .addCase(Actions.SET_FIREBASE_POPUP_OPEN, (state, action) => {
            state.firebasePopupOpen = action.firebasePopupOpen;
        })
        .addCase(Actions.SET_PROFILE_INITIALIZED, (state) => {
            state.profileInitialized = true;
        })
        .addCase(Actions.SET_FETCHING_PROFILE, (state, action) => {
            state.fetchingProfile = action.fetchingProfile;
        });
});

export default profile;
